<template>
	<div id="index">
		<div style="margin: 60px;">
			<ServiceAgreement></ServiceAgreement>
		</div>
		<div  class="el-header">
			<HeaderMenu style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"></HeaderMenu>
		</div>
		<pageFooter></pageFooter>

	</div>

</template>

<script>
	import HeaderMenu from "./HeaderMenu.vue";
	import pageFooter from "./pageFooter.vue";
	import ServiceAgreement from "./ServiceAgreement.vue";

	export default {
		name: "index",
		data() {
			return {
				// fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
				// url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
			}
		},
		components: {
			HeaderMenu,
			pageFooter,
			ServiceAgreement
		},
		created() {},
		methods: {
			toOmission() {
				window.location.href = "https://omissionvr.com/vue"
			},
			toMeeting() {
				window.location.href = "https://omissionvr.com/screen"
			}
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}

	html,
	body {
		width: 100%;
		height: 100%;
		scroll-behavior: smooth;
	}

	.omission-title {
		text-shadow: #000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0;

	}

	.el-header {
		position: relative;
		width: 100%;
		/* height: 60px; */
		padding: 0;
		z-index: 1000;
		background: #FFFFFF;
	}

	.el-main {
		position: absolute;
		left: 0;
		right: 0;
		top: 60px;
		bottom: 0;
		/* overflow-y:scroll; */

	}

	.bg {
		width: 100%;
		height: 100%;
		/**宽高100%是为了图片铺满屏幕 */
		z-index: -1;
		position: absolute;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
	}

	.sec {
		position: relative;
		width: 100%;
		height: 100vh;
	}

	/* 	#section1 {
		background: url(../assets/p1.png) center center / cover no-repeat;
	} */

	#section2 {
		background: url(../assets/p2.png) center center / cover no-repeat;
	}

	/* 
	#section3 {
		background: url(../assets/p3.png) center center / cover no-repeat;
	} */

	/* 	.sec::after {
		position: absolute;
		bottom: 0;
		left: 0;
		content: '';
		width: 100%;
		height: 90%;
				background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, .8) 90%, rgba(0, 0, 0, .8) 100%);
			background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, .8) 90%, rgba(0, 0, 0, .8) 100%);
	
		z-index: 1;
	} */

	.sec h1 {
		position: absolute;
		font-size: 50px !important;
		top: 15%;
		left: 50%;
		z-index: 2;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		color: #161616;
		font: normal 300 64px/1 'Josefin Sans', sans-serif;
		text-align: center;
		white-space: nowrap;
		font-weight: 600;
	}

	.demo a {
		position: absolute;
		bottom: 20px;
		left: 50%;
		z-index: 2;
		display: inline-block;
		-webkit-transform: translate(-50%, -30%);
		transform: translate(-50%, -30%);
		color: #161616;
		font: normal 400 20px/1 'Josefin Sans', sans-serif;
		letter-spacing: .1em;
		text-decoration: none;
		transition: opacity .3s;
		font-weight: 800;
	}

	.demo a:hover {
		opacity: .5;
	}



	#section2 a {
		padding-top: 60px;
	}

	#section2 a span {
		position: absolute;
		top: 0;
		left: 50%;
		width: 24px;
		height: 24px;
		margin-left: -12px;
		border-left: 1px solid #161616;
		border-bottom: 1px solid #161616;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		-webkit-animation: sdb04 2s infinite;
		animation: sdb04 2s infinite;
		box-sizing: border-box;
	}

	@-webkit-keyframes sdb1 {
		0% {
			-webkit-transform: translate(0, 0);
			opacity: 0;
		}

		40% {
			opacity: 1;
		}

		80% {
			-webkit-transform: translate(0, 20px);
			opacity: 0;
		}

		100% {
			opacity: 0;
		}
	}

	@keyframes sdb1 {
		0% {
			transform: translate(0, 0);
			opacity: 0;
		}

		40% {
			opacity: 1;
		}

		80% {
			transform: translate(0, 20px);
			opacity: 0;
		}

		100% {
			opacity: 0;
		}
	}

	#section1 a {
		padding-top: 60px;
	}

	#section1 a span {
		position: absolute;
		top: 0;
		left: 50%;
		width: 24px;
		height: 24px;
		margin-left: -12px;
		border-left: 1px solid #FFFFFF;
		border-bottom: 1px solid #FFFFFF;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		-webkit-animation: sdb04 2s infinite;
		animation: sdb04 2s infinite;
		box-sizing: border-box;
	}

	@-webkit-keyframes sdb04 {
		0% {
			-webkit-transform: rotate(-45deg) translate(0, 0);
		}

		20% {
			-webkit-transform: rotate(-45deg) translate(-10px, 10px);
		}

		40% {
			-webkit-transform: rotate(-45deg) translate(0, 0);
		}
	}

	@keyframes sdb04 {
		0% {
			transform: rotate(-45deg) translate(0, 0);
		}

		20% {
			transform: rotate(-45deg) translate(-10px, 10px);
		}

		40% {
			transform: rotate(-45deg) translate(0, 0);
		}
	}

	.container {
		padding: 1em 0;
		float: left;
		width: 50%;
		height: 200px;
		z-index: 3;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
	}

	@media screen and (max-width: 640px) {
		.container {
			display: block;
			width: 100%;
		}
	}

	@media screen and (min-width: 900px) {
		.container {
			width: 33.33333%;
		}
	}

	.container .title {
		color: #1a1a1a;
		text-align: center;
		margin-bottom: 10px;
	}

	.content {
		position: relative;
		width: 300px;
		height: 200px;
		margin: auto;
		overflow: hidden;
		border-radius: 25px;
	}

	.content .content-overlay {
		background: rgba(0, 0, 0, 0.7);
		position: absolute;
		height: 99%;
		width: 100%;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		opacity: 0;
		-webkit-transition: all 0.4s ease-in-out 0s;
		-moz-transition: all 0.4s ease-in-out 0s;
		transition: all 0.4s ease-in-out 0s;
	}

	.content:hover .content-overlay {
		opacity: 1;
	}

	.content-image {
		width: 100%;
	}

	.content-details {
		position: absolute;
		text-align: center;
		padding-left: 1em;
		padding-right: 1em;
		width: 100%;
		top: 50%;
		left: 50%;
		opacity: 0;
		-webkit-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		-webkit-transition: all 0.3s ease-in-out 0s;
		-moz-transition: all 0.3s ease-in-out 0s;
		transition: all 0.3s ease-in-out 0s;
	}

	.content:hover .content-details {
		top: 50%;
		left: 50%;
		opacity: 1;
	}

	.content-details h3 {
		color: #fff;
		font-weight: 500;
		letter-spacing: 0.15em;
		margin-bottom: 0.5em;
		text-transform: uppercase;
	}

	.content-details p {
		color: #fff;
		font-size: 0.8em;
		margin: 0.5em;
		line-height: 2;
		text-indent: 10px;
	}
	.fadeIn-top {
		top: 20%;
	}

	.fadeIn-left {
		left: 20%;
	}

	.fadeIn-right {
		left: 80%;
	}



	.button-container {
		width: 100%;
		display: flex;
		margin: 60px auto;
		flex-wrap: wrap;
		justify-content: center;
	}

	.button {
		display: flex;
		overflow: hidden;
		margin: 10px;
		padding: 12px 12px;
		cursor: pointer;
		user-select: none;
		transition: all 150ms linear;
		text-align: center;
		white-space: nowrap;
		text-decoration: none !important;
		text-transform: none;
		text-transform: capitalize;
		color: #fff;
		border: 0 none;
		border-radius: 36px;
		font-size: 13px;
		font-weight: 500;
		line-height: 1.3;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		justify-content: center;
		align-items: center;
		flex: 0 0 160px;
		/* box-shadow: 2px 5px 10px #e4e4e4; */
	}

	.button:hover {
		transition: all 150ms linear;
		opacity: .85;
	}

	.button:active {
		transition: all 150ms linear;
		opacity: .75;
	}

	.button:focus {
		outline: 1px dotted #959595;
		outline-offset: -4px;
	}

	.button.-dark {
		color: #FFFFFF;
		background: #161616;
	}

	.button.-dark:focus {
		outline: 1px dotted white;
		outline-offset: -4px;
	}

	.button.-white {
		color: #161616;
		background: #FFFFFF;
	}

	.button.-white:focus {
		outline: 1px dotted white;
		outline-offset: -4px;
	}
</style>
